<template>
  <DragDialog
    title="构件查询"
    :width="600"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="closeDialog"
  >
    <QueryForm v-if="isQueryFormVisible" :dataSetList="dataSetList" />
  </DragDialog>
</template>

<script>
import DragDialog from "@/components/CustomDragDialog.vue";
import QueryForm from "./QueryForm.vue";

export default {
  data() {
    return {
      isQueryFormVisible: true,
    };
  },
  props: {
    visible: Boolean,
    dataSetList: Array,
    closeDialog: Function,
  },
  components: { DragDialog, QueryForm },
  methods: {},
};
</script>

<style lang="less" scoped>
:deep(.dialog-content) {
  padding: 0px !important;
}
</style>